Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Vimeo = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../utils");
var _generalObserver = require("../general-observer");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Vimeo = function Vimeo(_ref) {
  var vimeoId = _ref.vimeoId,
    _ref$autoPlay = _ref.autoPlay,
    autoPlay = _ref$autoPlay === void 0 ? false : _ref$autoPlay,
    _ref$skipTo = _ref.skipTo,
    skipTo = _ref$skipTo === void 0 ? {
      h: 0,
      m: 0,
      s: 0
    } : _ref$skipTo;
  var h = skipTo.h,
    m = skipTo.m,
    s = skipTo.s;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, null, /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "vimeo",
    className: "vimeo-mdx-embed",
    style: _objectSpread({
      position: 'relative',
      width: '100%'
    }, (0, _utils.getPadding)('16:9'))
  }, /*#__PURE__*/_react["default"].createElement("iframe", {
    title: "vimeo-".concat(vimeoId),
    src: "https://player.vimeo.com/video/".concat(vimeoId, "?autoplay=").concat(autoPlay, "#t=").concat(h, "h").concat(m, "m").concat(s, "s"),
    frameBorder: "0",
    allow: "autoplay; fullscreen",
    allowFullScreen: true,
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%'
    }
  })));
};
exports.Vimeo = Vimeo;